import React from 'react';

export const COLOUR2 = {
  BLUE: '#072241',
  WHITE: '#ffffff',
};
const IconCompletionDate = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.77539 5.82248C1.77539 5.07775 2.37854 4.47363 3.12424 4.47363H31.4568C32.2016 4.47363 32.8057 5.07775 32.8057 5.82248V31.4564C32.8057 32.2021 32.2016 32.8053 31.4568 32.8053H3.12424C2.37854 32.8053 1.77539 32.2021 1.77539 31.4564V5.82248Z"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52196 1.77539V8.52157"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0591 1.77539V8.52157"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.77539 11.2197H32.8057"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0363 22.0128C24.0363 25.7384 21.0167 28.759 17.2901 28.759C13.5646 28.759 10.5449 25.7384 10.5449 22.0128C10.5449 18.2872 13.5646 15.2666 17.2901 15.2666"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5918 21.3379L16.7775 22.9767C17.0645 23.1929 17.4708 23.1444 17.6997 22.869L24.0357 15.2666"
        stroke="#8F4E6D"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconCompletionDate;
